import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ADD_BUSINESS_PATH, HAVE_A_BUSINESS_COPY } from "@/lib/growthHooks";

/** Subtle #23 hook — single inline line, no popup. */
export function HaveABusinessHook({ className = "", testID = "have-a-business-hook" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const href = user
    ? ADD_BUSINESS_PATH
    : `/login?redirect=${encodeURIComponent(ADD_BUSINESS_PATH)}`;

  return (
    <p className={`text-sm text-muted-foreground ${className}`} data-testid={testID}>
      <Link
        to={href}
        className="text-brand-green underline-offset-2 hover:underline"
        data-testid={`${testID}-link`}
        onClick={(e) => {
          // Prefer client nav so auth redirect is consistent
          e.preventDefault();
          nav(href);
        }}
      >
        {HAVE_A_BUSINESS_COPY}
      </Link>
    </p>
  );
}
